module.exports = __webpack_public_path__ + "img/小暑.b88a611e.jpg";